import GroupAnalytics from './GroupAnalytics';

export default GroupAnalytics;
